import { gsap } from 'gsap';
import { md } from '../common';
import { disableScroll, enableScroll } from '../lib/scroll';
import { onSamePageHashLinkClick } from '../lib/onSamePageHashLinkClick';

function initMainMenu(topbar) {
  const overlay = topbar.querySelector('.topbar-mini__overlay');
  const hamburger = topbar.querySelector('.topbar-mini__hamburger');

  hamburger.setAttribute('aria-expanded', 'false');

  const open = () => {
    topbar.classList.add('is-menu-open');
    hamburger.setAttribute('aria-expanded', 'true');
    disableScroll();
  };
  const close = () => {
    topbar.classList.remove('is-menu-open');
    hamburger.setAttribute('aria-expanded', 'false');
    enableScroll();
  };
  const toggle = () =>
    topbar.classList.contains('is-menu-open') ? close() : open();

  hamburger.addEventListener('click', toggle);
  overlay.addEventListener('click', close);

  gsap.matchMedia().add(`(min-width: ${md}px)`, () => {
    close();
  });

  onSamePageHashLinkClick(topbar, () => {
    if (topbar.classList.contains('is-menu-open')) {
      close();
    }
  });
}

export function initTopbarMini() {
  const topbar = document.querySelector('.topbar-mini');
  if (!topbar) return;

  gsap.to(topbar, { opacity: 1, duration: 0.3, ease: 'power4.in' });

  initMainMenu(topbar);
}
